import React, { createContext, useContext, useState, useEffect } from 'react';

// Cria o contexto do tema
const ThemeContext = createContext();

// Provedor do contexto que irá envolver a aplicação
export const ThemeProvider = ({ children }) => {
  // Estado inicial do tema, buscando a preferência do usuário do localStorage
  // ou a preferência do sistema operacional
  const [theme, setTheme] = useState(() => {
    const localTheme = localStorage.getItem('theme');
    if (localTheme) {
      return localTheme;
    }
    // O Portal do Servidor usa o visual claro aprovado como primeira experiência.
    // Uma escolha explícita do usuário continua preservada no localStorage.
    return 'light';
  });

  // Atualiza a classe 'dark' no elemento <html> quando o tema muda
  useEffect(() => {
    const root = window.document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    // Persiste a preferência do tema no localStorage
    localStorage.setItem('theme', theme);
  }, [theme]);

  // Função para alternar entre os temas
  const toggleTheme = () => {
    setTheme(currentTheme => (currentTheme === 'dark' ? 'light' : 'dark'));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

// Hook customizado para facilitar o consumo do contexto em qualquer componente
export const useTheme = () => useContext(ThemeContext);